import type * as Types from 'app/types/graphql';

import { PageEdgeSelectFragmentDoc, PageSelectFragmentDoc } from '../fragments/pages.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type PagesQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  before?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderBy?: Types.InputMaybe<Types.PageOrder>;
  where?: Types.InputMaybe<Types.PageWhereInput>;
}>;

export type PagesQueryResponse = {
  pages?: Types.Maybe<{
    edges: Array<{
      node?: Types.Maybe<
        Pick<Types.Page, 'baseId' | 'title' | 'handle' | 'publishedAt' | 'templateSuffix'>
      >;
    }>;
    pageInfo?: Types.Maybe<Pick<Types.PageInfo, 'hasNextPage' | 'endCursor'>>;
  }>;
};

export const PagesDocument = `
    query Pages($after: Cursor, $before: Cursor, $first: Int, $last: Int, $orderBy: PageOrder, $where: PageWhereInput) {
  pages(
    after: $after
    before: $before
    first: $first
    last: $last
    orderBy: $orderBy
    where: $where
  ) {
    edges {
      ...PageEdgeSelect
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PageEdgeSelectFragmentDoc}
${PageSelectFragmentDoc}`;

export const usePagesQuery = <TData = PagesQueryResponse, TError = unknown>(
  variables?: PagesQueryVariables,
  options?: UseQueryOptions<PagesQueryResponse, TError, TData>,
) => {
  return useQuery<PagesQueryResponse, TError, TData>(
    variables === undefined ? ['Pages'] : ['Pages', variables],
    appFetcher<PagesQueryResponse, PagesQueryVariables>(PagesDocument, variables),
    options,
  );
};

usePagesQuery.getKey = (variables?: PagesQueryVariables) =>
  variables === undefined ? ['Pages'] : ['Pages', variables];
